<template>
  <div class="container-list">
    <div class="flex">
      <!-- <unitList @select="getUnit" @getFirst="getOne"></unitList> -->
      <unitList v-show="!($store.state.user.userInfo.natureId == 2)" @getFirst="getOne" @select="getUnit"></unitList>
      <div class="flex1">
        <div class="common-page common-head">
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            灭火记录
          </div>
        </div>

        <div class="common-page common-body">
          <div class="common-page common-tool-bar" style="justify-content: space-between">
            <div class="flex"></div>
            <div class="flex">
              <div class="ml20">
                <el-button v-hasPermi="['plan:firerecord:fireExtinguishingPlan']" class="ml20" icon="el-icon-switch-button" type="primary" @click.native="sendMessage"
                >预案灭火启动
                </el-button
                >
                <el-button icon="el-icon-search" type="primary" @click="showSearchBtn">查询</el-button>
                <el-button icon="el-icon-refresh-right" type="primary" @click="cancle">重置</el-button>
              </div>
              <!-- type:  0 只查看  1 可编辑   page:0 演练记录 1 灭火记录  -->
            </div>
          </div>
          <div class="common-page common-list">
            <el-table :data="list" class="">
              <el-table-column align="center" label="名称" prop="drill_name"></el-table-column>
              <el-table-column align="center" label="时间" prop="drill_time"></el-table-column>
              <el-table-column align="center" label="灭火区域" prop="drill_weizhi"></el-table-column>
              <el-table-column align="center" label="灭火记录" prop="c_create_time">
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      path: '/plan/fireExtionguishingDetails',
                      query: {
                        id: scope.row.id,
                        page: 1,
                        type: 1,
                        c_num: cpNum,
                      },
                    }"
                    v-hasPermi="['plan:firerecord:fireRecordInfo']"
                  >
                    <el-button plain size="mini" type="success">查看详情</el-button>
                  </router-link>
                </template>
              </el-table-column
              >

              <el-table-column align="center" fixed="right" label="操作" width="200px">
                <template slot-scope="scope">
                  <el-popconfirm
                      v-hasPermi="['plan:firerecord:remove']"
                      class="cursor"
                      title="确定删除此项吗？"
                      @confirm="changeStatus(scope.row, 2)"
                      @onConfirm="changeStatus(scope.row, 2)"
                  >
                    <a slot="reference">
                      <el-button size="mini" type="danger">删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination :current-page.sync="params.page" :page-size="10" :total="total" background layout="prev, pager, next" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="true" :visible.sync="showDia" title="查询">
      <el-form ref="form" :model="form" label-width="110px">
        <el-form-item label="名称" prop="login_pass">
          <el-input v-model="form.drill_name"></el-input>
        </el-form-item>
        <el-form-item label="一级分区" prop="user_phone">
          <el-select v-model="form.drill_tower" filterable placeholder="请选择" @change="changetower">
            <el-option v-for="(item, index) in units" :key="index" :label="item.tower" :value="item.tower" @change="changetower($event, index)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分区" prop="user_phone">
          <el-select v-model="form.drill_tier" filterable placeholder="请选择">
            <el-option v-for="item in select2" :key="item" :label="item" :value="item">{{ item }}</el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="center">
        <el-button size="small" type="primary" @click="searchSubmit">确定</el-button>
        <el-button plain size="small " type="info" @click="showDia = false">取消</el-button>
      </div>
    </el-dialog>
    <message v-if="$store.state.user.userInfo.natureId == 2 || $store.state.user.id == 1" ref="message" :showDia="showDia1" :type="2"/>
  </div>
</template>

<script>
import unitList from "@/components/unitList";
import message from "@/components/message.vue";

export default {
  components: {
    unitList,
    message,
  },
  data() {
    return {
      cpNum: "",

      list: [],
      groups: ["大哥"],
      params: {
        page: 1,
        drill_status: "1",
        drill_tower: "",
        drill_tier: "",
        drill_name: "",
        starttime: "",
        endtime: "",
        company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
      },
      form: {
        starttime: "",
        drill_tower: "",
        drill_tier: "",
        drill_name: "",
      },
      messForm: {
        type: "",
        addr: "",
        ess: "",
        person: [],
      },
      people: [],
      select2: [],
      units: [],
      total: 0, // 总数
      showDia: false, // 查询
      checkAll: false, //选择全部
      showDia1: false, // 下发短信
      searchForm: this.$getForm("safePlace"),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    // this.getList();
  },
  methods: {
    sendMessage() {
      this.$refs.message.showDia1 = true;
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    changetower(val, index) {
      this.units.map((item, index) => {
        if (item.tower === val) {
          this.select2 = item.tierList;
        }
      });
    },
    handleCheckAllChange(val) {
      this.people = val ? this.groups : [];
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.groups.length;
    },
    changeStatus(it) {
      this.$post(`drill/deljilu/${it.drill_uuid}`).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
        this.getList();
      });
    },
    cancle() {
      this.params.page = 1;
      this.select2=[]
      this.resetSearch();
      this.getList();
      // this.showDia = false;
    },

    // 生成二维码
    //  跳转添加
    link() {
      this.$route.push("/plan/drill-add");
    },

    getList() {
      this.$post("/drill/drilllist", this.params).then((res) => {
        this.list = res.data.list;
        this.total = res.data.count;
      });
    },
    getList1() {
      this.$post("/score/maintenancelist", this.params).then((res) => {
        this.list = res.data.list;
        this.count = res.count;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.params = {...this.params, ...this.form};
      this.getList();
      this.showDia = false;

      //  打印
    },
    resetSearch() {
      this.form = {
        starttime: "",
        drill_tower: "",
        drill_tier: "",
        drill_name: "",
      };
      this.params = {
        page: 1,
        drill_status: "1",
        drill_tower: "",
        drill_tier: "",
        drill_name: "",
        starttime: "",
        endtime: "",
        company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
      };
    },
    showSearchBtn() {
      this.showDia = true;
      const companyNum = this.params.company_num;
      this.$get(`/drillplan/planJianzhu/planArea/${companyNum}`).then((res) => {
        this.units = res.data;
      });
    },
  },

  watch: {
    cpNum() {
      this.params.company_num = this.cpNum;
      this.params.page = 1;
      this.getList();
    },
  },
};
</script>

<style scoped>
.el-dialog .el-dialog__body {
  padding: 0 !important;
}
</style>
